var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 33,
    r: 30,
    fill: "#00A6A6",
    stroke: "white",
    strokeWidth: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M43 28.77V30H23V28.54C23 26.25 24.86 24.4 27.15 24.4H37V26.97C37 28.24 37.76 29 39.03 29H41.97C42.37 29 42.71 28.93 43 28.77Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 30V37.46C23 39.75 24.86 41.6 27.15 41.6H38.85C41.14 41.6 43 39.75 43 37.46V30H23ZM29 38.25H27C26.59 38.25 26.25 37.91 26.25 37.5C26.25 37.09 26.59 36.75 27 36.75H29C29.41 36.75 29.75 37.09 29.75 37.5C29.75 37.91 29.41 38.25 29 38.25ZM35.5 38.25H31.5C31.09 38.25 30.75 37.91 30.75 37.5C30.75 37.09 31.09 36.75 31.5 36.75H35.5C35.91 36.75 36.25 37.09 36.25 37.5C36.25 37.91 35.91 38.25 35.5 38.25Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.97 22H39.03C37.76 22 37 22.76 37 24.03V26.97C37 28.24 37.76 29 39.03 29H41.97C43.24 29 44 28.24 44 26.97V24.03C44 22.76 43.24 22 41.97 22ZM42.63 24.45L40.26 27.22C40.17 27.33 40.03 27.4 39.89 27.4C39.88 27.4 39.88 27.4 39.87 27.4C39.73 27.4 39.6 27.35 39.5 27.25L38.4 26.17C38.2 25.97 38.2 25.64 38.4 25.44C38.6 25.24 38.93 25.23 39.13 25.44L39.83 26.13L41.83 23.79C42.02 23.57 42.34 23.55 42.56 23.73C42.79 23.91 42.81 24.24 42.63 24.45Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.0511fee6e610c0a3ee6bc931e1fbe516.svg";
export { ForwardRef as ReactComponent };